import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import {
  BuildingMultiSelect,
  BuildingSelectFormikField,
} from '../../../../Building'
import { Checkbox, CHECKBOX_SIZE, CHECKBOX_TYPE } from '../../../../Checkbox'
import { FieldStackedLabel } from '../../../../Field'
import { FormFieldsContainer } from '../../../../Form'
import {
  FormikEntityActionConfigFields,
  FormikField,
  getFormikCheckboxFieldValueProps,
  getFormikFormFieldErrorProps,
  useFormikEntityActionConfigFieldsClearFields,
} from '../../../../Formik'
import {
  BUILDING_GROUP_EDIT_BUILDINGS_FIELD_NAME_BUILDING,
  BUILDING_GROUP_EDIT_BUILDINGS_FIELD_NAME_UPDATE_MANAGERS,
  EDIT_BUILDING_FORM_INITIAL_VALUES,
} from '../BuildingGroupsEditBuildingsActionModal.constants'

import * as styles from './FormFields.module.css'

function FormFields({ actionTypes, isLoading }) {
  const { t } = useTranslation()

  const { errors, setFieldValue, values } = useFormikContext()

  useEffect(() => {
    if (
      values[BUILDING_GROUP_EDIT_BUILDINGS_FIELD_NAME_BUILDING].length === 0
    ) {
      setFieldValue(
        BUILDING_GROUP_EDIT_BUILDINGS_FIELD_NAME_UPDATE_MANAGERS,
        false
      )
    }
  }, [values[BUILDING_GROUP_EDIT_BUILDINGS_FIELD_NAME_BUILDING]])

  const { actionTypeValueIsRemoveAll } =
    useFormikEntityActionConfigFieldsClearFields({
      emptyValues: EDIT_BUILDING_FORM_INITIAL_VALUES,
    })

  const disabledCheckbox =
    values[BUILDING_GROUP_EDIT_BUILDINGS_FIELD_NAME_BUILDING].length === 0 &&
    !actionTypeValueIsRemoveAll

  return (
    <FormFieldsContainer>
      <FormikEntityActionConfigFields
        typeSelectProps={{
          error: errors[BUILDING_GROUP_EDIT_BUILDINGS_FIELD_NAME_BUILDING],
          options: actionTypes,
        }}
      >
        <BuildingSelectFormikField
          multi
          Field={FieldStackedLabel}
          Select={BuildingMultiSelect}
          controlProps={{
            contentProps: {
              inputProps: {
                placeholder: t('BuildingGroup.BuildingFieldPlaceholderKey'),
              },
            },
          }}
          disabled={actionTypeValueIsRemoveAll}
          fieldComponentProps={{
            isLoading,
            label: `${t('BuildingGroup.BuildingFieldLabelKey')}:`,
          }}
          name={BUILDING_GROUP_EDIT_BUILDINGS_FIELD_NAME_BUILDING}
        />
        <FormikField
          showTooltip
          Component={Checkbox}
          disabled={disabledCheckbox}
          getErrorProps={getFormikFormFieldErrorProps}
          getValueProps={getFormikCheckboxFieldValueProps}
          label={t('BuildingGroup.UpdateManagersFieldLabelKey')}
          labelClassName={styles.checkboxLabel}
          labelTitleClassName={styles.checkboxLabelTitle}
          name={BUILDING_GROUP_EDIT_BUILDINGS_FIELD_NAME_UPDATE_MANAGERS}
          size={CHECKBOX_SIZE.small}
          tooltip={
            disabledCheckbox
              ? t('BuildingGroup.UpdateManagersFieldTooltipAddBuildingKey')
              : null
          }
          type={CHECKBOX_TYPE.action}
        />
      </FormikEntityActionConfigFields>
    </FormFieldsContainer>
  )
}

export default FormFields
